import React, { PureComponent } from 'react'
import GhostBanner from './components/GhostBanner'
import { getRecommendList } from '@app-core/place/actions'
import { openPlaceInRNMap } from '@libs/appUrl'
import { compose, connect, withBeacon } from '@hocs'
import { trackingShareProperty } from '@app-core/beacon/beacon'

class GhostBannerContainer extends PureComponent {
  componentDidMount() {
    this._fetchRecommendChoicePlaces()
  }

  componentDidUpdate(prevProps) {
    const { ghost: prevGhost } = prevProps
    const { ghost } = this.props
    if (ghost.get('postID') !== prevGhost.get('postID')) {
      this._fetchRecommendChoicePlaces()
    }
  }

  _fetchRecommendChoicePlaces() {
    const { ghost, getRecommendList } = this.props
    const placeId = ghost.get('postID')
    const lat = ghost.getIn(['place', 'coordinates', 'lat'])
    const lng = ghost.getIn(['place', 'coordinates', 'lng'])

    getRecommendList({ placeId, lat, lng, requestType: 'ghostRelatedPlaceIds' })
  }

  _onClick = () => {
    const { ghost, amplitudeEventTrack } = this.props
    openPlaceInRNMap(ghost)
    amplitudeEventTrack('click.top.rn.map', trackingShareProperty(ghost))
  }

  render() {
    const ghost = this.props.ghost.toJS()
    const recommendPlaces = this.props.recommendPlaces.toJS()
    return <GhostBanner ghost={ghost} recommendPlaces={recommendPlaces} onClick={this._onClick} />
  }
}

function mapStateToProps(state, ownProps) {
  const { placeId } = ownProps
  const places = state.place.get('places')
  const recommendPlaces = state.place
    .get('ghostRelatedPlaceIds')
    .setSize(5)
    .map((placeId) => places.get(placeId))
  return { ghost: places.get(placeId), recommendPlaces }
}

export default compose(
  withBeacon,
  connect(mapStateToProps, {
    getRecommendList,
  }),
)(GhostBannerContainer)
